'use client';

import MyPointCard from '@/app/(football)/[team]/_components/common/MyPointCard';

export default function HeroSection() {
  return (
    <div className="flex w-full flex-col items-center">
      <h1 className="typo-heading-1 text-white">포인트 라운지</h1>
      <p className="pt-2 text-center typo-body-5 text-white">획득한 포인트로 상품에 응모하고</p>
      <p className="pt-0.5 text-center typo-body-5 text-white">이벤트를 통해 더 많은 포인트를 모아보세요</p>

      <div className="mt-6 w-full">
        <MyPointCard />
      </div>
    </div>
  );
}
